<script setup lang="ts">
import { mdiClose, mdiInformation } from "@mdi/js";
import Button from "~/components/ui/Button.vue";
import Icon from "~/components/ui/Icon.vue";
import Modal from "~/components/ui/Modal.vue";
import { INews } from "~/types/config/news";
import t from "~/utils/translate";

interface Props {
	news: INews;
}

defineProps<Props>();
const emits = defineEmits(["handle-close"]);
const modalActive = ref(false);
</script>

<template>
	<Modal
		v-if="modalActive"
		anchor="top"
		size="small"
		:title="t(`message-box.${news.summary}_summary`)"
		:active="modalActive"
		@set-active="(val) => (modalActive = val)"
	>
		{{ t(`message-box.${news.fullMessage}_body`) }}
	</Modal>
	<div
		class="bg-light-50 dark:bg-dark-800 shadow md:rounded w-full flex justify-between items-center px-2 h-10 dark:text-light-50 overflow-hidden gap-1 whitespace-nowrap"
	>
		<div class="overflow-hidden flex gap-1">
			<Icon :path="mdiInformation" class="w-6 h-6 fill-identity flex-shrink-0" />
			<span class="overflow-hidden text-ellipsis">
				{{ t(`message-box.${news.summary}_summary`) }}
			</span>
		</div>
		<div class="flex gap-1">
			<Button :label="t('more-info')" variant="identity" size="small" @click="modalActive = !modalActive" />
			<Button
				variant="secondary"
				:icon="mdiClose"
				:ariaLabel="t('close-news-info-banner')"
				size="small"
				icon-class="m-0 w-5 h-5 fill-light-50"
				@click="emits('handle-close', news.id)"
			/>
		</div>
	</div>
</template>
